import './i18n';  //// import i18n (needs to be bundled ;)) 

let SearchDefaults = {
      
    /**
       	01 - BB  (breakfast board )
	      02 - HB  (half board)
	      03 - FB  (full board)
	      04 - BBT (breakfast board with treatment)
	      05 - HBT (half board with treatment)
	      06 - FBT (full board with treatment)
	      ff - BX  (маленький ребенок бесплатно)
       */
    dietaryTreatmentSettings: 
        { dietaryOptions: [
          //{value: 0, treatment: false, label: 'without meals, without treatment'}, // 0  
          {value: 1, meals: 1, treatment: false, label: '1 meals, without treatment'},       // 01 BB - (breakfast)
          {value: 2, meals: 2, treatment: false, label: '2 meals, without treatment'},       // 02 HB - (half board)
          {value: 3, meals: 3, treatment: false, label: '3 meals, without treatment'},       // 03 FB - (full board)
          //{value: 5, treatment: false, label: 'without meals, with treatment'},    // 
          {value: 4, meals: 1, treatment: true, label: '1 meals, with treatment'},          // 04 BBT - (breakfast with treatment)
          {value: 5, meals: 2, treatment: true, label: '2 meals, with treatment'},          // 05 HBT - (half board with treatment)
          {value: 6, meals: 3, treatment: true, label: '3 meals, with treatment'},          // 06 FBT - (full board with treatment)
        ] ,
    },
    dateRangeDefault: {checkInDate: null, checkOutDate: null},
};

(function() {
        // compute default check-in checkpout dayes 
        const today = new Date();
        const nextMondayDate = new Date(today.getTime() + (1 - today.getDay() + 7)*1000*60*60*24);
        const differenceInDays = Math.ceil(Math.abs(nextMondayDate - today.getTime()) / (1000 * 60 * 60 * 24));
        const checkInDate = differenceInDays <= 3
              ? new Date(nextMondayDate.setDate(nextMondayDate.getDate() + 7)) : nextMondayDate;
        const nextFriday = new Date(checkInDate);
        nextFriday.setDate(nextFriday.getDate() + 4);

        const dateRangeDefault = {
          checkInDate:checkInDate, checkOutDate: nextFriday
        };

        SearchDefaults.dateRangeDefault = dateRangeDefault;
})();

export default SearchDefaults;
